const fetchInitialState = {
  fetching: false,
  funnels: [],
};

const fetch = (state = fetchInitialState, action) => {
  switch (action.type) {
    case 'FETCH_FUNNELS':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_FUNNELS_SUCCESS':
      return {
        ...state,
        fetching: false,
        funnels: action.funnels,
      };

    case 'FETCH_FUNNELS_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'UPDATE_FUNNEL_SUCCESS': {
      if (!action.id) {
        return {
          ...state,
          funnels: [...state.funnels, action.funnel],
        };
      }

      const editedIndex = state.funnels.findIndex((f) => f.id === action.funnel.id);

      return {
        ...state,
        funnels: [
          ...state.funnels.slice(0, editedIndex),
          action.funnel,
          ...state.funnels.slice(editedIndex + 1),
        ],
      };
    }

    case 'DELETE_FUNNEL_SUCCESS': {
      const deletedIndex = state.funnels.findIndex((f) => f.id === action.id);

      return {
        ...state,
        funnels: [
          ...state.funnels.slice(0, deletedIndex),
          ...state.funnels.slice(deletedIndex + 1),
        ],
      };
    }

    default:
      return state;
  }
};

export default fetch;

export const areFetching = (state) => state.fetching;

export const getFunnels = (state) => state.funnels;
